import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`-mb-[0.14em] block overflow-hidden pb-[0.14em] ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Stagger = ({ children, className = "" }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.1 } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y: 24 },
      show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
    }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.24em] text-esaia-blue ${className}`}>
    {children}
  </p>
);

export const SectionHead = ({ kicker, title, copy, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
    {kicker && <Kicker className={align === "center" ? "text-center" : ""}>{kicker}</Kicker>}
    <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-esaia-ink">
      {title}
    </h2>
    {copy && <p className="mt-5 text-base leading-relaxed text-esaia-muted">{copy}</p>}
  </Reveal>
);
